module.exports = __webpack_public_path__ + "img/nofind.8e47d054.png";